module.exports = __webpack_public_path__ + "img/home_bg.967abefe.png";